import React, { useState, useEffect, useRef } from "react"
import { Paper, Button } from "@mui/material"
import { BrandingSection } from "./BrandingSection"
import { DomainUrlSection } from "./DomainUrlSection"
import { FeaturedArticleSection } from "./FeaturedArticleSection"
import { AddFeaturedArticlePopup } from "./AddFeaturedArticlePopup"
import { useDispatch, useSelector } from "react-redux"
import { toggleArticleFeature } from "../../../../store/features/getKbArticles"
import { fetchFeaturedArticles } from "../../../../store/features/getFeaturedArticles"

export const SettingsSidebar = ({ settings, onSettingChange, onLogoUpload, onSaveChanges, loading, initialSyncDone, groupId }) => {
    const dispatch = useDispatch();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const initialSettings = useRef(null);

    const {
        articles: featuredArticles,
        loading: featuredLoading,
        hasFetched: featuredHasFetched,
        lastFetchedBusinessId,
    } = useSelector((state) => state.featuredArticles);
    const business_id = useSelector((state) => state.loginToken?.response?.user?.business_id);
    const featuredReadyForCurrentBusiness =
        featuredHasFetched &&
        String(lastFetchedBusinessId) === String(business_id);
    const shouldShowFeaturedLoading =
        Boolean(business_id) && (featuredLoading || !featuredReadyForCurrentBusiness);


    useEffect(() => {
        initialSettings.current = null;
        setHasChanges(false);
    }, [groupId]);

    useEffect(() => {
        if (initialSyncDone && !initialSettings.current) {
            initialSettings.current = JSON.stringify(settings);
        }
    }, [initialSyncDone, settings]);


    useEffect(() => {
        if (initialSettings.current) {
            const isChanged = JSON.stringify(settings) !== initialSettings.current;
            setHasChanges(isChanged);
        }
    }, [settings]);

    useEffect(() => {
        if (business_id && groupId) {
            dispatch(fetchFeaturedArticles({ business_id, group_id: groupId }));
        }
    }, [business_id, groupId, dispatch]);

    const handleSettingChange = (key, value) => {
        onSettingChange(key, value);
    };

    const handleLogoUpload = (file) => {
        onLogoUpload(file);
        setHasChanges(true);
    };

    const handleSaveChanges = () => {
        onSaveChanges();
        // After saving, update the initial reference to current settings
        initialSettings.current = JSON.stringify(settings);
        setHasChanges(false);
    };

    const handleOpenPopup = () => setIsPopupOpen(true);

    const handlePopupClose = () => {
        setIsPopupOpen(false);
        if (business_id && groupId) {
            dispatch(fetchFeaturedArticles({ business_id, group_id: groupId }));
        }
    };

    const handleRemoveArticle = (article) => {
        const id = article.id || article._id;
        dispatch(toggleArticleFeature({ articleId: id, isFeatured: false, group_id: groupId }));
    };

    return (
        <Paper
            sx={{
                width: 344,
                p: 3,
                borderRadius: '8px',
                border: "1px solid #E5E9EC",
                backgroundColor: "#FFF",
                flexShrink: 0,
                fontFamily: "Inter",
                boxShadow: 'none',
                height: '100%'
            }}
        >
            <BrandingSection
                settings={settings}
                onSettingChange={handleSettingChange}
                onLogoUpload={handleLogoUpload}
                loading={loading}
            />

            <FeaturedArticleSection
                onAddClick={handleOpenPopup}
                selectedArticles={featuredArticles}
                onRemoveArticle={handleRemoveArticle}
                loading={shouldShowFeaturedLoading}
            />

            {/* <DomainUrlSection
                settings={settings}
                onSettingChange={handleSettingChange}
                loading={loading}
            /> */}

            <Button
                onClick={handleSaveChanges}
                disabled={!hasChanges}
                sx={{
                    width: 296,
                    height: 40,
                    borderRadius: "8px",
                    backgroundColor: hasChanges ? "#148DFD" : "#F9FAFA",
                    color: hasChanges ? "#FFF" : "#93A1B0",
                    fontFamily: "Inter",
                    border: hasChanges ? "none" : "1px solid #C5CED6",
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "18px",
                    textTransform: "none",
                    boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
                    "&:hover": {
                        backgroundColor: hasChanges ? "#1179D5" : "#F9FAFA",
                    },
                }}
            >
                Save Changes
            </Button>

            <AddFeaturedArticlePopup
                open={isPopupOpen}
                onClose={handlePopupClose}
                groupId={groupId}
            />
        </Paper>
    )
}